import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './../styles/sidebar.css';

const Sidebar = ({ endpoints, activeEndpoint, onSelect }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <>
      <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-header">
          <h3>{isCollapsed ? 'Nav' : 'Navigation'}</h3>
          <button className="collapse-btn" onClick={toggleSidebar}>
            {isCollapsed ? '>' : '<'}
          </button>
        </div>
        <ul className="sidebar-menu">
          {endpoints.map((endpoint) => (
            <li
              key={endpoint.id}
              className={`sidebar-item ${
                activeEndpoint === endpoint.id ? 'active' : ''
              }`}
              onClick={() => onSelect(endpoint.id)}
            >
              <NavLink
                to={`/dashboard?tab=${endpoint.id}`}
                className="sidebar-link"
                activeClassName="active"
              >
                {isCollapsed ? (
                  <span title={endpoint.name}>{endpoint.icon || endpoint.name.charAt(0)}</span>
                ) : (
                  endpoint.name
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Sidebar;